import "amazon-connect-streams";
import type { VoiceTask } from "@/sdk/agent/voice/voiceTask";

import hasCustomerLeft from "./hasCustomerLeft";

/**
 * Returns true when an unexpected customer disconnect occurred and the chime should play.
 *
 * Callers must first establish that the task is a voice task (e.g. via `isVoiceTask`); this
 * helper only answers the "is this an unexpected disconnect" question for a voice call. It is
 * true only when:
 * - The call was active (assigned) when it ended — not a missed/pending ring or normal wrap-up
 * - The customer leg has dropped (customer is no longer connected)
 * - The agent did not intentionally end/transfer the call
 *
 * Amazon Connect's Streams SDK does not expose a disconnect reason, so an intentional customer
 * hangup and a carrier drop are indistinguishable client-side — both are treated as an unexpected
 * disconnect (matching the previous Twilio behavior).
 */
export function shouldPlayDisconnectChime(
    task: VoiceTask,
    contact: connect.Contact,
    agentEndedContactIds: ReadonlySet<string>,
): boolean {
    return task.status === "assigned" && hasCustomerLeft(contact) && !agentEndedContactIds.has(contact.contactId);
}
